/**
 * @internal Backs `artis.v1.deployment`: a state channel with catch-up for late
 * subscribers. The deployment monitor calls `applyLatest`; consumers subscribe through
 * {@link DeploymentApi}, not this class.
 */
export class DeploymentStore {
    state;
    subs = new Set();
    constructor(current) {
        this.state = { current, latest: undefined, isOutdated: false };
    }
    applyLatest = (latest) => {
        const { current, isOutdated } = this.state;
        const next = { current, latest, isOutdated: isOutdated || latest !== current };
        if (next.latest === this.state.latest && next.isOutdated === this.state.isOutdated)
            return;
        this.state = next;
        for (const cb of this.subs)
            cb(next);
    };
    subscribe = (cb) => {
        this.subs.add(cb);
        cb(this.state);
        return () => void this.subs.delete(cb);
    };
}
//# sourceMappingURL=deploymentStore.js.map